import React from 'react'
import {Stack, Typography} from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined'
import {useTranslation} from 'react-i18next'

import {colors} from '@/constants'
import HoverButton from '@/components/UI/button/HoverButton'
import TransCustom from '@/components/UI/i18next'
import LoiReferral from '@/components/Modals/Profile/ReferralSystem/LoiReferral'

export const LOI_GAME_TAB_LABEL = 'LOI GAME'
const LOI_GAME_URL = 'https://legendsofinteractions.com'

const LoiGame = () => {
  const {t} = useTranslation()

  return (
    <Stack height="100%" width="80%" minHeight={0} gap="20px">
      <Typography variant="h1" color={colors.yellow} flex="none">
        {LOI_GAME_TAB_LABEL}
      </Typography>

      <Stack
        flex="none"
        gap="12px"
        padding="18px 20px"
        boxSizing="border-box"
        sx={{
          border: `1px solid ${colors.orange}66`,
          borderRadius: '14px',
          background: '#FF93260D',
        }}>
        <Stack direction="row" alignItems="center" gap="10px">
          <ScienceOutlinedIcon
            style={{color: colors.orange, fontSize: '24px'}}
          />
          <TransCustom
            i18nKey="1825"
            color={colors.orange}
            fontSize="18px"
            fontWeight="600"
          />
        </Stack>
        <TransCustom
          i18nKey="1826"
          color={colors.white}
          fontSize="14px"
          lineHeight="150%"
        />
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          gap="16px"
          flexWrap="wrap">
          <TransCustom i18nKey="1827" color={colors.gray} fontSize="14px" />
          <HoverButton
            onClick={() =>
              window.open(LOI_GAME_URL, '_blank', 'noopener,noreferrer')
            }
            fontSize="15px"
            fontWeight="500"
            height="40px"
            padding="8px 20px"
            gap="8px"
            textColor={colors.brown}
            background={colors.orange}>
            {t('1828')}
            <OpenInNewIcon style={{fontSize: '18px'}} />
          </HoverButton>
        </Stack>
      </Stack>

      <TransCustom
        i18nKey="1829"
        color={colors.lightBrown}
        fontSize="18px"
        fontWeight="600"
        flex="none"
      />
      <Stack flex="auto" minHeight={0}>
        <LoiReferral />
      </Stack>
    </Stack>
  )
}

export default LoiGame
